export { Textarea } from './Textarea';
export type { TextareaProps } from './Textarea.types';
